import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { Observable } from 'rxjs'
import { CountableSummary } from 'src/app/models/period-aggregate-amounts.model'
import { getLoading, getUmhpPageUserviews } from 'src/app/selectors/period-aggregate-amounts.selector'
import { Artist } from 'src/app/models/artist.model'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import {
  getDataCollectByUmphUserviews,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-umhp-userview',
    templateUrl: './aggregated-amounts-umhp-userview.component.html',
    styleUrls: ['./aggregated-amounts-umhp-userview.component.scss'],
    standalone: false
})
export class AggregatedAmountsUmhpUserviewComponent implements OnInit {

  umhpPageUserview$: Observable<CountableSummary>
  selectedArtist$: Observable<Artist>
  loading$: Observable<boolean>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) { }

  ngOnInit() {
    this.umhpPageUserview$ = this.store.select(getUmhpPageUserviews)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByUmphUserviews)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
